export default __webpack_public_path__ + "static/media/uploader-abbottNeo-4.815c43c9.png";